
import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import { ListUsers, User } from '../../webservices/models';

@Component({
    name: 'ApiFavUsersTable',
})
export default class FavUsersTable extends Vue {
    private mainStore = mainStore.context(this.$store);

    private get favUsers(): ListUsers[] {
        return this.mainStore.state.favApiUsers;
    }

    private get isLoading(): boolean {
        return this.mainStore.state.isLoading;
    }

    private openUser(user: User): void {
        this.mainStore.actions.changeCurrentUser(user);
        this.$router.push({ name: 'User' });
    }
}
